
/*
 * @Description:
 * @Author: dingxuejin
 * @Date: 2021-02-05 21:25:33
 * @LastEditTime: 2021-02-15 20:55:08
 * @LastEditors: dingxuejin
 */
import { lazy, PureComponent as Component } from "react";
import './index.scss';

const BaseLayout = lazy(() => import("@/components/layout/baseLayout"));

class NomalLayout extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dj-nomalLayout">
                <BaseLayout layout="2" {...this.props}>{this.props.children}</BaseLayout>
            </div >
        );
    }
}

export default NomalLayout;

